import { render, staticRenderFns } from "./GlobalPromotionImportList.vue?vue&type=template&id=fd1aa214&scoped=true"
import script from "./GlobalPromotionImportList.vue?vue&type=script&lang=js"
export * from "./GlobalPromotionImportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1aa214",
  null
  
)

export default component.exports